/* esm.sh - d3-transition@3.0.1/src/transition/ease */
export * from "/*d3-transition@3.0.1/esnext/src/transition/ease.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/transition/ease.mjs";
